import { Colors, Lightning, Utils } from '@lightningjs/sdk'

export default class SettingsButton extends Lightning.Component {
  static _template() {
    return {
      alpha: 0.6,
      Title: {
        w: 600,
        h: 45,
        color: Colors('white').get(),
        text: { text: this.bindProp('title'), fontSize: 28, fontFace: 'OpenSansRegular' },
      },
      BottomLine: { w: 800, h: 2, y: 50, rect: true, color: Colors('white').get() },
      FocusWrapper: {
        w: 600,
        h: 0,
        y: 60,
        alpha: 0.0001,
        Descr: {
          w: 555,
          h: 120,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('descr'),
            fontSize: 35,
            wordWrapWidth: 555,
            wordWrap: true,
            fontFace: 'OpenSansLight',
          },
        },
        LinkText: {
          w: 555,
          h: 35,
          y: 150,
          color: Colors('white').get(),
          text: { text: this.bindProp('linkText'), fontSize: 22, fontFace: 'OpenSansBold' },
        },
      },
      QrWrapper: {
        w: 200,
        h: 200,
        x: 600,
        y: 60,
        rect: true,
        color: 0xffffffff,
        alpha: 0.001,
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 10 },
        transitions: { alpha: { duration: 2, delay: 0.4, timingFunction: 'ease-out' } },
        QRimage: {
          x: 200 / 2,
          y: 200 / 2,
          w: 180,
          h: 180,
          mount: 0.5,
          transitions: { alpha: { duration: 2, delay: 0.4, timingFunction: 'ease-out' } },
        },
      },
    }
  }

  set buttonData(data) {
    this.patch({
      title: data.title,
      descr: data.descr,
      linkText: data.link,
    })

    this._showQR(data.qrLink)

    this.h = 60
  }

  get topPos() {
    return this._top
  }

  _init() {
    this.tag('Title').on('txLoaded', () => {
      this._top = this.finalY
    })
  }

  _showQR(link) {
    setTimeout(() => {
      this.tag('QRimage').src = Utils.asset(link)
    }, 500)
  }

  _hideQR() {
    this.patch({
      QrWrapper: { smooth: { alpha: [0.001, { duration: 0 }] } },
    })
  }

  _focus() {
    this.patch({
      smooth: {
        h: [280, { duration: 0.2, timingFunction: 'ease-in' }],
        alpha: [1, { duration: 0.2, timingFunction: 'ease-in' }],
      },
      FocusWrapper: {
        smooth: {
          alpha: [1, { duration: 0.2, timingFunction: 'ease-in' }],
          h: [80, { duration: 0.2, timingFunction: 'ease-in' }],
        },
      },
      QrWrapper: {
        smooth: {
          alpha: [1, { duration: 0.6, delay: 0.6, timingFunction: 'ease-out' }],
        },
      },
    })
  }

  _unfocus() {
    this.patch({
      smooth: {
        h: [60, { duration: 0.2, timingFunction: 'ease-in' }],
        alpha: [0.6, { duration: 0.2, timingFunction: 'ease-in' }],
      },
      FocusWrapper: {
        smooth: {
          alpha: [0.0001, { duration: 0.2, timingFunction: 'ease-in' }],
          h: [0, { duration: 0.2, timingFunction: 'ease-in' }],
        },
      },
      QrWrapper: {
        smooth: {
          alpha: [0, { duration: 0.2, timingFunction: 'ease-out' }],
        },
      },
    })
  }
}
